"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRelevantQuote = void 0;

var _immutable = require("immutable");

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var getRelevantQuote = function getRelevantQuote(activeQuotes, hub) {
  if (activeQuotes.size < 1) return null;
  var hubMerchIds = (0, _immutable.Set)(_HubMap.default[hub].merchandise);
  var relevantQuote = activeQuotes.filter(function (quote) {
    var recurringCharges = quote.get('recurringCharges') || (0, _immutable.List)();
    var nonRecurringCharges = quote.get('nonRecurringCharges') || (0, _immutable.List)();
    var relevantRecurringCharge = recurringCharges.find(function (charge) {
      return hubMerchIds.has(charge.get('itemId'));
    });
    var relevantNonRecurringCharge = nonRecurringCharges.find(function (charge) {
      return hubMerchIds.has(charge.get('itemId'));
    });
    return relevantRecurringCharge || relevantNonRecurringCharge;
  }).sortBy(function (quote) {
    return quote.get('id');
  }).last();
  return relevantQuote;
};

exports.getRelevantQuote = getRelevantQuote;